import { Injectable } from "@angular/core";
import { AppConfig } from "../shared/constants/app.config";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class AuthorizationService {
  constructor(readonly http: HttpClient,
    ) { }

  getEhrCode(url: string) {
    const segments = url.split("?")[1].split("&");
    for (const element of segments) {
      if (element.startsWith("code=")) {
        return element.replace("code=", "").split("#")[0];
      }
    }
    return null;
  }

  getEhrState(url: string) {
    const segments = url.split("?")[1].split("&");
    for (const element of segments) {
      if (element.startsWith("state=")) {
        return element.replace("state=", "").split("#")[0];
      }
    }
    return null;
  }

  codeToBearerToken(tokenurl: string, code: string, state: any, validState: any) {
    if (!validState || validState !== state) {
      return Promise.reject(new Error("Invalid or missing state."));
    }

    //HTTP Post request  get Bearer token
    const body =
      `grant_type=authorization_code&code=${code}&redirect_uri=${AppConfig.EHR_OAUTH_REDIRECT_URL}&client_id=${encodeURIComponent(AppConfig.EHR_CLIENT_ID)}`;

    return this.http
      .post(tokenurl, body, {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .toPromise();
  }

  constructAuthorizationUrl(baseUrl: string, launchToken: string, aud: string | number | boolean, state: string | number | boolean) {
    const urlScopeReDirect = `scope=launch&response_type=code&redirect_uri=${encodeURIComponent(AppConfig.EHR_OAUTH_REDIRECT_URL)}`;
    const urlClientIdLaunch = `client_id=${encodeURIComponent(AppConfig.EHR_CLIENT_ID)}&launch=${launchToken}`;
    const urlAudState = `aud=${encodeURIComponent(aud)}&state=${encodeURIComponent(state)}`;
    return `${baseUrl}?${urlScopeReDirect}&${urlClientIdLaunch}&${urlAudState}`;
  }

  getMetadata(url: string) {
    const metadata = url + "/metadata";
    return this.http
      .get(metadata, {
        headers: new HttpHeaders({
          Accept: "application/fhir+json",
        }),
      })
      .toPromise();
  }

  getAuthorizeUrl(data: any) {
    const rests = data["rest"];
    for (const restObj of rests) {
      const security = restObj["security"],
        outerExtensions = security["extension"];
      for (const outerExtensionObj of outerExtensions) {
        const innerExtension = outerExtensionObj["extension"];
        for (const extension of innerExtension) {
          if (extension["url"] === "authorize") {
            console.log("getAuthorizeUrl ->" + extension["valueUri"]);
            return extension["valueUri"];
          }
        }
      }
    }
    return null;
  }

  getTokenUrl(data: any) {
    const rests = data["rest"];
    for (const restObj of rests) {
      const security = restObj["security"],
        outerExtensions = security["extension"];
      for (const outerExtensionObj of outerExtensions) {
        const innerExtension = outerExtensionObj["extension"];
        for (const extension of innerExtension) {
          if (extension["url"] === "token") {
            console.log("getTokenUrl ->" + extension["valueUri"]);
            return extension["valueUri"];
          }
        }
      }
    }
    return null;
  }

  getCibmtrFhirUrl(data: any) {
    const fhirVers = data["fhirVersion"];
    if (fhirVers.startsWith('4')) {
      return AppConfig.CIBMTR_FHIR_R4_URL;
    }
    else if (fhirVers.startsWith('3')) {
      return AppConfig.CIBMTR_FHIR_R3_URL;
    }
    return null;
  }

  getFhirVersion(data: any) {
    return data["fhirVersion"].startsWith('4') ? "R4" : "STU3";
  }

  //TODO : possibility of getting invalid ISS should be handled.
  getIss(absUrl: string) {
    const urlSegments = absUrl.split("?");
    let params: string | any[];
    if (urlSegments.length > 1) {
      params = urlSegments[1].split("&");
    } else {
      params = urlSegments[0].split("&");
    }

    for (const element of params) {
      const pv = element.split("=");
      if (pv[0] === "iss") {
        return decodeURIComponent(pv[1]);
      }
    }
    return null;
  }

  getLaunchToken(absUrl: string) {
    const urlSegments = absUrl.split("?");
    let params: string | any[];
    if (urlSegments.length > 1) {
      params = urlSegments[1].split("&");
    } else {
      params = urlSegments[0].split("&");
    }

    for (const element of params) {
      const pv = element.split("=");
      if (pv[0] === "launch") {
        return pv[1].split("#")[0];
      }
    }
    return null;
  }
}
